import React from "react";
import PropTypes from "prop-types";
import { COMPONENT_TYPE } from "@learningblocks/exp-constants/lib/Utilities";
import { Button } from "@learningblocks/shared-components";
import style from "./style.module.scss";

/**
 * HintButton for the Question footer component;
 */
export function HintButton(props) {
  const className = `${style.button} ${props.className}`;

  const showHint = () => {
    const { componentID, componentType } = props;
    props.showHint(componentID, componentType);
  };

  return (
    <Button
      onClick={showHint}
      type="secondary"
      disabled={props.disabled}
      className={className}
    >
      {props.firstHint ? "Get hint" : "Get another hint"}
    </Button>
  );
}

HintButton.propTypes = {
  /**
   * The unique id for the question component
   */
  componentID: PropTypes.number,
  /**
   * String for the component Type
   */
  componentType: PropTypes.oneOf([
    COMPONENT_TYPE.CSCQ,
    COMPONENT_TYPE.MSCQ,
    COMPONENT_TYPE.DDQ,
    COMPONENT_TYPE.DNDQ_COLOR,
    COMPONENT_TYPE.GROUPED_DNDQ,
    COMPONENT_TYPE.CSCQ_COLOR,
    COMPONENT_TYPE.QUESTION_TABLE,
  ]),
  /**
   * Boolean value controlling button enabled/disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Callback function involked when showHint is clicked
   */
  showHint: PropTypes.func.isRequired,
};
